import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import styles from "./InputGroup.module.css";

const CopyShortcodeInput = ({
  label,
  id,
  placeholder = "",
  value: defaultValue = "",
}) => {
  const [value, setValue] = useState(defaultValue);
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (text) => {
    // Fallback method for environments where navigator.clipboard isn't available
    if (navigator.clipboard && window.isSecureContext) {
      // Modern method with clipboard API
      return navigator.clipboard.writeText(text);
    } else {
      // Fallback method for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand("copy");
        if (!successful) {
          throw new Error("Copy command failed");
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };

  const handleCopy = async () => {
    try {
      await copyToClipboard(value);
      setIsCopied(true);
      
      // Reset copied status after 2 seconds
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      setIsCopied(false);
      
      // Optional: Show error message if needed
      // alert('Failed to copy to clipboard. Please try again.');
    }
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const handleClick = () => {
    handleCopy();
  };

  return (
    <div className={styles["hvnly_settings_api__form-group"]}>
      {label && (
        <label
          className={styles["hvnly_settings_api__form-label"]}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <div className={styles["hvnly_settings_api__input-wrapper"]}>
        <input
          type="text"
          id={id}
          className={`${styles["hvnly_settings_api__form-control"]} ${styles["hvnly_settings_api__copy-input"]}`}
          value={value}
          placeholder={placeholder}
          onFocus={handleFocus}
          onClick={handleClick}
          readOnly
        />
        <button
          type="button"
          className={styles["hvnly_settings_api__copy-button"]}
          onClick={handleCopy}
          aria-label={__("Copy to clipboard", "havenlytics")}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        </button>
        
        {isCopied && (
          <div className={styles["hvnly_settings_api__copy-toast"]}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {__("Copied to clipboard", "havenlytics")}
          </div>
        )}
      </div>
    </div>
  );
};

export default CopyShortcodeInput;